import * as React from 'react';
import styled from 'styled-components';
import { Card, CardSize } from '../../shared/card/Card';
import ClickOutside from '../../shared/ClickOutside';
import { InnerPopups, TopLevelPopup } from './Popups';

interface IProps {
  onClose: () => void;
  style?: React.CSSProperties;
  children: React.ReactNode;
  noClickOutside?: boolean;
  size?: CardSize;
}

const popupCardStyles = {
  backgroundColor: 'var(--color-popup-background)',
  boxShadow: 'var(--shadow-elevation-12)',
};

export const PopupCard = (props: IProps): React.ReactElement => {
  if (!props.noClickOutside) {
    return (
      <ClickOutside onClickOutside={props.onClose}>
        <Card
          size={props.size}
          style={{
            ...popupCardStyles,
            ...props.style,
          }}
        >
          <InnerPopups />
          {props.children}
        </Card>
      </ClickOutside>
    );
  }
  return (
    <Card
      size={props.size}
      style={{
        ...popupCardStyles,
        ...props.style,
      }}
    >
      <InnerPopups />
      {props.children}
    </Card>
  );
};

export const InnerPopupCard = (props: IProps): React.ReactElement => {
  if (!props.noClickOutside) {
    return (
      <ClickOutside onClickOutside={props.onClose}>
        <Card
          size={props.size}
          style={{
            ...popupCardStyles,
            ...props.style,
          }}
        >
          <TopLevelPopup />
          {props.children}
        </Card>
      </ClickOutside>
    );
  }
  return (
    <Card
      size={props.size}
      style={{
        ...popupCardStyles,
        ...props.style,
      }}
    >
      <TopLevelPopup />
      {props.children}
    </Card>
  );
};

export const PopupCardContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const PopupCardSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: 5px;
  &:last-child {
    margin-top: auto;
    align-items: flex-end;
  }
`;
